import { apiRequest } from './api';

export const contactService = {
  getContactSettings: () => apiRequest('/api/contact'),
  submitEnquiry: (data) => apiRequest('/api/contact/enquiry', {
    method: 'POST',
    body: JSON.stringify(data)
  })
};
